<script setup lang="ts">
import Okay from '../icons/OkayIcon.vue';
import { defineProps } from 'vue';
import { usePurchaseStore } from '@/dashboard/store/purchaseStore';
import poster from '@/../assets/images/new_theme/illustration/success_team_il.png';

const props = defineProps<{
  title: string;
}>();

const purchaseStore = usePurchaseStore();
</script>

<template>
  <div class="h-[631px] w-[738px]">
    <div class="relative h-[559px]">
      <img :src="poster" class="h-full w-full object-contain" alt="" />
    </div>

    <div class="flex items-center justify-between py-[20px] pl-m pr-[20px]">
      <div class="flex items-center gap-xs whitespace-nowrap">
        <okay class="h-m w-m fill-green" />
        <span class="text-black dark:text-gray-500">{{ props.title }}</span>
      </div>

      <div class="flex w-[112px]">
        <button class="tppr-button ghost s" @click="() => purchaseStore.closePopup()">
          <span class="tppr-button__text">Got it!</span>
        </button>
      </div>
    </div>
  </div>
</template>
